export default "/images/nab.png?03d8c5999489ec376ce283b978b6aa93";